import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { CustomPage } from 'src/app/models/custom-page-model';
import { CustomTable } from 'src/app/models/custom-table-model';
import { Studio } from 'src/app/models/studio-model';
import { DateFormatterService } from 'src/app/services/date-formatter/date-formatter.service';
import { DefaultService } from 'src/app/services/default/default.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-opening-slots',
  templateUrl: './opening-slots.component.html',
  styleUrls: ['./opening-slots.component.scss']
})
export class OpeningSlotsComponent implements OnInit {
  custom_page: CustomPage;

  show_pagination: boolean = true;
  show_delete_button: boolean = true;
  show_edit_button: boolean = true;
  visible_actions: Array<any> = [];
  invisible_actions: Array<any> = [];
  multi_actions: Array<any> = [];
  index: string = "id";


  searchForm: FormGroup;
  loading: boolean = true;
  query: string = "";
  customTable: CustomTable;
  limit: number = 10;
  count_items: number = 0;
  current_page: number = 1;
  nbr_pages: number = 1;
  results: Array<any> = [];
  pageNums: Array<number> = [];
  studio: Studio = new Studio();
  loading_title: boolean = true;

  currentLink: string = "";

  custom_buttons: Array<any> = [
    {
      text: '<i class="fa fa-sync"></i> Actualiser',
      class: "btn btn-xl btn-primary",
      action: () => {
        this.redirectTo("/opening-slots", {});
      },
    },
  ];

  columns: Array<any> = [
    {
      key: "day_selected",
      type: "enum",
      value: "Jour séléctionné",
      concat_value: "",
      field_relation: "",
      class: { monday: "badge badge-primary", tuesday: "badge badge-primary", wednesday: "badge badge-primary", thursday: "badge badge-primary", friday: "badge badge-primary", saturday: "badge badge-primary", sunday: "badge badge-primary" },
      text: { monday: "Lundi", tuesday: "Mardi", wednesday: "Mercredi", thursday: "Jeudi", friday: "Vendredi", saturday: "Samedi", sunday: "Dimanche" },
      list: [
        { value: "monday", text: "Lundi" },
        { value: "tuesday", text: "Mardi" },
        { value: "wednesday", text: "Mercredi" },
        { value: "thursday", text: "Jeudi" },
        { value: "friday", text: "Vendredi" },
        { value: "saturday", text: "Samedi" },
        { value: "sunday", text: "Dimanche" },
      ]
    },
    {
      key: "start_time",
      type: "text",
      class: "font-weight-bold",
      value: "Heure de début",
      concat_value: "",
      field_relation: "",
    },
    {
      key: "end_time",
      type: "text",
      class: "font-weight-bold",
      value: "Heure de fin",
      concat_value: "",
      field_relation: "",
    },
    {
      key: "full_day",
      type: "check",
      value: "Jour entier",
      operation: "boolean",
      yes: '<span class="badge badge-success">OUI</span>',
      no: '<span class="badge badge-danger">NON</span>',
    },
  ];

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private modalService: NgbModal,
    private dateFormatterService: DateFormatterService,
    private defaultService: DefaultService,
    private location: Location
  ) { }


  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe(params => {
      this.activatedRoute.params.subscribe(route => {

        this.currentLink = "/studios/" + route.id + "/opening-slots";

        this.custom_page = new CustomPage("opening-slots", "", "heures d'ouvertures pour le studio", "", "&populate=studio&sort[0]=createdAt%3Adesc&filters[studio][id]=" + route.id);
        this.get_studio(route.id);
      });
      this.show_loading();
      this.current_page = (params["page"]) ? params["page"] : 1;
      this.limit = (params["limit"]) ? params["limit"] : this.limit;
      this.get_results(this.custom_page.filters);
    });
  }

  get_studio(id: string) {
    this.spinner.show();
    this.defaultService.get_one("studios", id).subscribe((res: any) => {
      this.studio = new Studio(Studio.attributeToJson(res.data));
      console.log(this.studio);
    }, err => {
      this.back();
      Swal.fire('Erreur', 'Aucune heure d\'ouverture trouvée', 'error');
    }).add(() => {
      this.spinner.hide();
      this.loading_title = false;
    });
  }

  do_search() {
    this.router.navigate([this.currentLink], { queryParams: { q: this.f.searchInput.value } });
  }

  get f() { return this.searchForm.controls; }

  change_limit(limit: any) {
    let query_params = {
      page: 1,
      limit: limit
    };
    if (this.query != "") {
      query_params["q"] = this.query
    }

    this.router.navigate([this.currentLink], { queryParams: query_params });
  }

  get_results(custom_filter: string) {
    this.spinner.show();
    let filters = ((this.query != "") ? "&_q=" + this.query : "") + custom_filter;
    let selected_route = this.custom_page.endpoint + this.custom_page.custom_route;
    this.defaultService.get_light(selected_route, this.limit, this.current_page, this.show_pagination, filters).subscribe((res: any) => {
      if (Array.isArray(res)) {
        this.results = res;
      } else {
        this.customTable = new CustomTable(this.custom_page.endpoint);
        let data_from_api = res.data;
        this.results = this.customTable.get_array_data(data_from_api);
        if (this.show_pagination) {
          this.count_items = res.meta.pagination.total;
          this.nbr_pages = res.meta.pagination.pageCount;
          this.generate_paginations();
        }
      }
    }, err => {
      this.results = [];
    }).add(() => {
      this.loading = false;
      this.spinner.hide();
    });
  }

  generate_paginations() {
    this.pageNums = [];
    if (this.nbr_pages <= 5) {
      for (let i = 1; i <= this.nbr_pages; i++) {
        this.pageNums.push(i);
      }
    } else {
      let page = Number.parseInt(this.current_page.toString());
      if (page < 3) {
        for (let i = 1; i <= 3; i++) {
          this.pageNums.push(i);
        }
        this.pageNums.push(NaN);
        this.pageNums.push(this.nbr_pages);
      } else {
        this.pageNums.push(1);
        if (page != 3) {
          this.pageNums.push(NaN);
        }
        let numBefore = page - 1;
        let numAfter = page + 1;
        if (page == this.nbr_pages) {
          for (let i = (numBefore - 1); i <= this.nbr_pages; i++) {
            this.pageNums.push(i);
          }
        } else {
          for (let i = numBefore; i <= numAfter; i++) {
            this.pageNums.push(i);
          }
          if (page == this.nbr_pages - 2) {
            this.pageNums.push(this.nbr_pages);
          } else if (page != this.nbr_pages - 1) {

            this.pageNums.push(NaN);
          }
        }
      }
    }
  }

  checkIsNumber(page: any) {
    if (Number.isNaN(page)) {
      return false;
    } else {
      return true;
    }
  }

  next() {
    return (this.current_page == this.nbr_pages) ? this.nbr_pages : (Number(this.current_page) + 1);
  }

  previous() {
    return (this.current_page == 1) ? 1 : (Number(this.current_page) - 1);
  }

  show_loading() {
    this.results = [];
    this.loading = true;
  }

  generate_route_query(page: number) {
    let query_params = {
      page: page,
      limit: this.limit
    };
    if (this.query != "") {
      query_params["q"] = this.query
    }
    return query_params;
  }

  redirectTo(uri: string, params: any) {
    this.router
      .navigateByUrl("/", { skipLocationChange: false })
      .then(() => this.router.navigate([uri], { queryParams: params }));
  }

  back() {
    this.location.back();
  }

  goTo(url: string) {
    this.router.navigate([url]);
  }

  get_params_for_add() {
    return { studio : this.studio?.id};
  }

  change_filters(key: string, event: any) {
    this.get_results((event.target.value == "") ? "" : "&filters[" + key + "]=" + event.target.value);
  }

}